var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_1140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.133 2.42592C17.133 2.26213 17.0896 2.10126 17.0072 1.95974C16.9247 1.81821 16.8062 1.70109 16.6637 1.62034C16.5212 1.53958 16.3598 1.49808 16.196 1.50007C16.0323 1.50205 15.8719 1.54746 15.7314 1.63165L6.69453 7.05083H3.24714C1.71229 7.05083 0.469971 8.2913 0.469971 9.828V17.2375C0.469971 18.7723 1.71044 20.0147 3.24714 20.0147H6.69453L15.7296 25.4375C15.8701 25.5222 16.0306 25.568 16.1947 25.5702C16.3587 25.5724 16.5204 25.531 16.6632 25.4502C16.806 25.3694 16.9248 25.2521 17.0073 25.1103C17.0898 24.9685 17.1332 24.8073 17.133 24.6433V2.42592ZM24.922 13.5272L27.54 16.1433L26.231 17.4523L23.6131 14.8362L20.9951 17.4523L19.6861 16.1433L22.3041 13.5272L19.6861 10.9111L20.9951 9.60212L23.6131 12.2182L26.2328 9.60212L27.54 10.9111L24.922 13.5272Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_1140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.07,
    height: 27.07,
    fill: "white",
    transform: "translate(0.469971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOffIcon);
export default __webpack_public_path__ + "static/media/sound-off-icon.fb23698b8a86fe2ce1ba78dd32066270.svg";
export { ForwardRef as ReactComponent };